import { render, staticRenderFns } from "./BeneficiosIcms.vue?vue&type=template&id=b81a3a4e&scoped=true&"
import script from "./BeneficiosIcms.vue?vue&type=script&lang=js&"
export * from "./BeneficiosIcms.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiosIcms.vue?vue&type=style&index=0&id=b81a3a4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81a3a4e",
  null
  
)

export default component.exports